import { useFela } from 'react-fela';
import { FormattedMessage, useIntl } from 'react-intl';

import config from '@/config';
import { useGetAdminPricing } from '@/modules/api/codegen';
import { Heading, Loader, Pane } from '@/modules/ui';

import { DeleteSecrets } from '../DeleteSecrets';
import { OrderInfo } from '../OrderInfo';
import { SettingsForm } from '../SettingsForm';
import { SettingsFormProvider } from '../SettingsFormProvider';
import { SettingsLink } from '../SettingsLink';
import { VaultsSettingsLink } from '../VaultsSettingsLink';
import * as felaRules from './Settings.rules';

export const Settings = () => {
    const { css } = useFela();

    const { formatMessage } = useIntl();

    const { data: adminPricing, isLoading } = useGetAdminPricing();

    if (isLoading) {
        return <Loader />;
    }

    return (
        <div className={css(felaRules.container)}>
            <Heading elementType='h1' color='black' customStyle={felaRules.title}>
                <FormattedMessage id='settings.title' />
            </Heading>
            <OrderInfo adminPricingSettings={adminPricing?.data} />
            <SettingsFormProvider>
                <Pane extend={{ container: felaRules.settingsPane }}>
                    <SettingsForm />
                    <SettingsLink to={config.routes.tagsSettings} title={formatMessage({ id: 'settings.links.tags' })} />
                    <VaultsSettingsLink />
                    <SettingsLink
                        to={config.routes.groupsVisibilitySettings}
                        title={formatMessage({ id: 'settings.links.groupsVisibility' })}
                    />
                    <DeleteSecrets />
                </Pane>
            </SettingsFormProvider>
        </div>
    );
};
